/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {WelcomeEmailCustomizationSaveRequest} from '../models/WelcomeEmailCustomizationSaveRequest';

export interface SaveWelcomeEmailCustomizations$Request {
    accountId: number;
    welcomeEmailCustomizationSaveRequest: WelcomeEmailCustomizationSaveRequest;
}

export interface SaveWelcomeEmailCustomizations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveWelcomeEmailCustomizationsRequest = createAction<PayloadData<void, SaveWelcomeEmailCustomizations$Request>>('SAVE_WELCOME_EMAIL_CUSTOMIZATIONS__SAVE_WELCOME_EMAIL_CUSTOMIZATIONS__REQUEST');
export const saveWelcomeEmailCustomizationsSuccess = createAction<PayloadData<void, SaveWelcomeEmailCustomizations$Request>>('SAVE_WELCOME_EMAIL_CUSTOMIZATIONS__SAVE_WELCOME_EMAIL_CUSTOMIZATIONS__SUCCESS');
export const saveWelcomeEmailCustomizationsFailure = createAction<PayloadData<Error, SaveWelcomeEmailCustomizations$Request, true>>('SAVE_WELCOME_EMAIL_CUSTOMIZATIONS__SAVE_WELCOME_EMAIL_CUSTOMIZATIONS__FAILURE');

export const saveWelcomeEmailCustomizationsActions = [
    saveWelcomeEmailCustomizationsRequest,
    saveWelcomeEmailCustomizationsSuccess,
    saveWelcomeEmailCustomizationsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {WelcomeEmailCustomizationSaveRequest} meta.welcomeEmailCustomizationSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveWelcomeEmailCustomizations = (meta: SaveWelcomeEmailCustomizations$Request, config?: SaveWelcomeEmailCustomizations$Config) => {
    return {
        CALL_API: {
            types: saveWelcomeEmailCustomizationsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/welcome-email-customizations`,
            TRANSPORT_REQUEST_BODY: meta.welcomeEmailCustomizationSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

